import { defineStore } from 'pinia'
import api from '@/api/modules/auth'
import * as Sentry from '@sentry/browser';
import { useAppMetadataStore } from '@/stores/appMetadata'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    errMess: '',
    pendingInvite: null,
    nextPage: null,
    companyId:null,
    permissions:null,
    admin:false,
    userFeatures: {}
  }),
  getters: {
    isAccountAdmin: (state) => state.admin === true,
    current_user: (state) => state.user,
    isFeatureActive: (state) => (feature) => {
      if (state.userFeatures) {
        return state.userFeatures.hasOwnProperty(feature)
          ? state.userFeatures[feature]
          : false;
      }
      return false;
    },
  },
  actions: {
    setFeatures(res){
      this.userFeatures = res
    },
    async login (email, pass, admin) {
        this.setErrMess(null)
        const formattedEmail = email.replace(/(^\s*)|(\s*$)/gi, "").toLowerCase();
        return api.authenticate(formattedEmail, pass, admin)
          .then(resp => {
            if (typeof resp === 'string' && resp.includes('https://login.microsoftonline.com')){
              window.location.replace(resp)
              return false
            }
            else{
              this.setUser(resp)
              this.setFeatures(resp['features'])
              this.setCurrentCompany(resp['companies'].filter(company => company.default === true)[0])
              const appMetadataStore = useAppMetadataStore();
              appMetadataStore.setBackendEnv(resp['backend_env'] ? resp['backend_env'] : null)
            }
            return true
          })
          .catch(err => {
            console.log("err",err)
              this.setUser(null)
              this.setFeatures({})
              this.setCurrentCompany(0)
              console.warn(err)
              Sentry.captureException(err)
           if (err.response.status === 403) {
              this.setErrMess(err.response.data)
               return false;
            } else if (err.response.status === 500) {
              this.setErrMess('Occoreu um erro. por favor tente novamente')
               return false;
            };

          })
      },
      async logout () {
        return api.logout()
          .then(resp => {
            this.setUser(null)
            this.setFeatures({})
            this.setCurrentCompany(0)
            return true
          })
          .catch(err => console.log(err))
      },
      async refreshUser (){
        return api.refresh_user()
            .then(resp => {
              this.setUser(resp)
              this.setFeatures(resp['features'])
              this.setCurrentCompany(resp['companies'].filter(company => company.default === true)[0])
              const appMetadataStore = useAppMetadataStore();
              appMetadataStore.setBackendEnv(resp['backend_env'] ? resp['backend_env'] : null)
            return true
            })
          .catch(err => {
              console.log(err)
              return false
          })
      },
      async changePassword(data){
          return api.changePassword(data)
              .then(resp => {
                  return resp
              })
              .catch(err => {console.log(err); return err})
      },
      async validateInviteToken (token){
        return api.validate_invite_token({'token': token})
            .then(resp => {
                return resp
            })
            .catch(err => {
              console.log(err)
              return err
            })
      },
      async setPasswordWithInviteToken (data){
        return api.validate_invite_token(data)
            .then(resp => {
              return resp
            })
            .catch(err => {
              console.log(err)
              return err
        })
      },
      async acceptInvite(token){
          return api.accept_invite_token(token)
            .then(resp => {
              return resp
            })
            .catch(err => {
              console.log(err)
              return err
        })
      },
      setUser(user){
        this.user = user
        user && Sentry.setUser({name: user.name, email: user.email })

      },
      setNextPage(next){
        this.nextPage=next
      },
      setErrMess(msg){
        this.errMess=msg
      },
      setPendingInvite(token){
        this.pendingInvite=token
      },
      setCurrentCompany(company) {
        if(company === 0){
          this.companyId = null
          this.permissions = null
          this.admin = false
        }else{
          this.companyId = company.id
          this.permissions = company.permissions
          this.admin = company.companyAdmin
        }
      },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'auth-store',
        storage: localStorage,
      },
    ],
  }
})
